import { useEffect, useRef, useState } from "react";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import { toast } from "react-toastify";
import { useMyContext } from "../../components/Provider/CommonProvider";
import AdminSwitch from "../../components/CommonComponents/AdminSwitch";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import { IconSolidEdit } from "../../Assets/MyIcons";
import AdminImageUploadZone from "../../components/CommonComponents/AdminImageUploadZone";
import { BsFiletypeXlsx } from "react-icons/bs";
import AdminDownloadFile from "../../components/CommonComponents/AdminDownloadFile";
import { DateRangePicker } from 'rsuite';
// import 'rsuite/DateRangePicker/styles/index.css';
// import 'rsuite/dist/rsuite.min.css';


import { Link } from 'react-router-dom'

const ImportExport = () => {
   const [showOverlay, setShowOverlay] = useState(false);
   const [optionValue, setOptionValue] = useState("");
   const [selectedSource, setSelectedSource] = useState("");
   const [fetchFromLibrary, setFetchFromLibrary] = useState(false);
   const [fetchLibraryValue, setFetchLibraryValue] = useState(0);
   const [columnList, setColumnList] = useState([]);
   const [columnSelection, setColumnSelection] = useState({});
   const [showLibraryModal, setShowLibraryModal] = useState(false);
   const [showEdit, setShowEdit] = useState(false);
   const [formDataFile, setFormDataFile] = useState("");
   const [formDataError, setFormDataError] = useState("");
   const [options, setOptions] = useState([]);
   const [sourceList, setSourceList] = useState([]);
   const [dateRange, setDateRange] = useState([]);
   const [selectedFields, setSelectedFields] = useState([]);
   const [exportFilePath, setExportFilePath] = useState("");
   const [exportFileName, setExportFileName] = useState("");
   const [importResults, setImportResults] = useState(null);
   const [contentType, setContentType] = useState(""); // "content_page" or "taxonomy"
   const [taxonomyGenre, setTaxonomyGenre] = useState("");

   // Simple Export state
   const [exportFormat, setExportFormat] = useState('xlsx'); // xlsx, csv

   // Enhanced Export state
   const [exportType, setExportType] = useState('simple'); // simple, enhanced
   const [includeRelationships, setIncludeRelationships] = useState(true);
   const [includeCustomFields, setIncludeCustomFields] = useState(true);
   const [exportMode, setExportMode] = useState('complete'); // complete, selected, filtered

   // Bulk Image Upload state
   const [bulkImages, setBulkImages] = useState([]);
   const [uploadProgress, setUploadProgress] = useState({});
   const [isDragging, setIsDragging] = useState(false);
   const [bulkUploadResults, setBulkUploadResults] = useState(null);

   // Define taxonomy genre options
   const taxonomyGenreOptions = [
      { value: "video_genre", name: "Video Genre" },
      { value: "series_genre", name: "Series Genre" },
      { value: "livestream_genre", name: "Livestream Genre" },
      { value: "audios_genre", name: "Audios Genre" }
   ];

   // Define content type options
   const contentTypeOptions = [
      { value: "content_page", name: "Contents" },
      { value: "taxonomy", name: "Taxonomy" },
      { value: "Artist", name: "Artist" },
      { value: "Language", name: "Language" }
   ];


   const combinedRef = useRef({});
   const [defaultOption, setDefaultOption] = useState({
      state: "defaultOption",
   })

   const { fetchRequest } = useMyContext();

   const baseURL = process.env.REACT_APP_Baseurl;
   const indexApi = `${baseURL}/admin/import-export/index`;
   const listApi = `${baseURL}/admin/export/list-data`;
   const downloadSampleApi = `${baseURL}/admin/download-sample-file`;
   const importData = `${baseURL}/admin/import-data`;
   const exportData = `${baseURL}/admin/export-data`;
   const simpleExportApi = `${baseURL}/admin/export-simple`;
   const enhancedExportApi = `${baseURL}/admin/export-enhanced`;
   const taxonomyExportApi = `${baseURL}/admin/export-taxonomy`;
   const uploadImagesApi = `${baseURL}/admin/import-export/upload-images`;

   const fetchData = async () => {
      try {
         setShowOverlay(true);
         await fetchRequest({
            method: 'GET',
            url: indexApi,
            params: {}
         })
            .then(response => {
               if (response?.status) {
                  const data = response?.data;
                  console.log("dataaa", response);
                  setOptions(data?.selectOption);
                  setSourceList(data?.sourceList);
                  toast.success(response?.message);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message);
            })
            .finally(() => {
               setShowOverlay(false);
            });
      } catch (error) {
         toast.error(error.message || "Something went wrong");
      }
   };

   const fetchSourceList = async (value) => {
      try {
         setShowOverlay(true);
         await fetchRequest({
            method: 'POST',
            url: listApi,
            data: { modal: value }
         })
            .then(response => {
               if (response?.status) {
                  const columns = response?.data?.columnList || {};
                  setColumnList(Object.keys(columns)); // set array of field names
                  setColumnSelection(columns);         // set initial field-value pairs
                  toast.success(response?.message);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message);
            })
            .finally(() => {
               setShowOverlay(false);
            });
      } catch (error) {
         toast.error(error.message || "Something went wrong");
      }
   };

   const fetchSampleDownload = async (sourceType = null) => {
      try {
         setShowOverlay(true);
         const params = sourceType ? { modal: sourceType } : {};
         await fetchRequest({
            method: 'GET',
            url: downloadSampleApi,
            params: params,
            data: {},
         })
            .then(response => {
               if (response?.status) {
                  setDefaultOption((prev) => ({
                     ...prev,
                     sampleFile: response?.sample_file,
                  }))
                  toast.success(response?.message);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message);
            })
            .finally(() => {
               setShowOverlay(false);
            });
      } catch (error) {
         toast.error(error.message || "Something went wrong");
      }
   }

   const handleImportData = async () => {
      try {

         if (formDataError?.length) {
            combinedRef.current['file'].focus()
            return
         }
         if (!formDataFile) {
            combinedRef.current['file'].focus()
            setFormDataError('Please provide xlsx file.');
            return
         }

         // For taxonomy, use taxonomyGenre as modal, for content_page use selectedSource
         const modal = contentType === "taxonomy" ? taxonomyGenre : selectedSource;

         const formData = new FormData();
         formData.append("file", formDataFile);
         formData.append("modal", modal);

         console.log("formData", formData);
         setShowOverlay(true)

         await await fetchRequest({
            method: 'POST',
            url: importData,
            params: {},
            data: formData
         })
            .then(response => {
               if (response?.status) {
                  toast.success(response?.message)
                  setFormDataFile(null)
                  setImportResults(response?.data) // Store detailed results
               }
            }).catch((error) => {
               toast.error(error?.response?.data?.message)
            }).finally(() => {
               setShowOverlay(false)
            })
      } catch (error) {
         toast.error(error.message || "Something went wrong");
      }
   }

   const handleExportData = async () => {
      try {
         setShowOverlay(true);

         // For taxonomy, use taxonomyGenre as modal, for content_page use selectedSource
         const modal = contentType === "taxonomy" ? taxonomyGenre : selectedSource;

         const data = {
            modal: modal,
            fetch_library: fetchLibraryValue,
            fetch_columns: selectedFields,
            start_date: dateRange[0] ? dateRange[0] : [],
            end_date: dateRange[1] ? dateRange[1] : [],
         };
         await fetchRequest({
            method: 'POST',
            url: exportData,
            params: {},
            data: data
         })
            .then(response => {
               if (response?.status) {
                  toast.success(response?.message);
                  setExportFilePath(response?.export_file_path);
                  setExportFileName(response?.export_file);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message);
            })
            .finally(() => {
               setShowOverlay(false);
            });
      } catch (error) {
         toast.error(error.message || "Something went wrong");
      }
   }

   const handleSimpleExport = async () => {
      try {
         setShowOverlay(true);

         // For taxonomy, use different API and modal setup
         if (contentType === "taxonomy") {
            const data = {
               modal: taxonomyGenre,
               format: exportFormat
            };

            await fetchRequest({
               method: 'POST',
               url: taxonomyExportApi,
               data: data
            })
               .then(response => {
                  if (response?.status) {
                     toast.success(response?.message);
                     setExportFilePath(response?.export_file_path);
                     setExportFileName(response?.export_file);
                  }
               })
               .catch(error => {
                  toast.error(error?.response?.data?.message);
               });
         } else {
            // For content pages, use simple export API
            const data = {
               modal: selectedSource,
               format: exportFormat,
               include_relationships: true,
               include_custom_fields: true,
               export_type: 'complete'
            };

            await fetchRequest({
               method: 'POST',
               url: simpleExportApi,
               data: data
            })
               .then(response => {
                  if (response?.status) {
                     toast.success(response?.message);
                     setExportFilePath(response?.export_file_path);
                     setExportFileName(response?.export_file);
                  }
               })
               .catch(error => {
                  toast.error(error?.response?.data?.message);
               });
         }

      } catch (error) {
         toast.error(error.message || "Something went wrong");
      } finally {
         setShowOverlay(false);
      }
   }

   const handleEnhancedExport = async () => {
      try {
         setShowOverlay(true);

         // For content pages, use enhanced export API
         const data = {
            modal: selectedSource,
            format: exportFormat,
            include_relationships: includeRelationships,
            include_custom_fields: includeCustomFields,
            export_type: exportMode,
            selected_columns: exportMode === 'selected' ? selectedFields : [],
            filters: {
               date_range: dateRange.length === 2 ? {
                  start: dateRange[0],
                  end: dateRange[1]
               } : null
            }
         };

         await fetchRequest({
            method: 'POST',
            url: enhancedExportApi,
            data: data
         })
            .then(response => {
               if (response?.status) {
                  toast.success(response?.message);
                  setExportFilePath(response?.export_file_path);
                  setExportFileName(response?.export_file);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message);
            });

      } catch (error) {
         toast.error(error.message || "Something went wrong");
      } finally {
         setShowOverlay(false);
      }
   }

   const handleOptionChange = (e) => {
      const { value } = e.target;
      setOptionValue(value);
      setSelectedSource("");
      setContentType("");
      setTaxonomyGenre("");

      // Clear the sample file when switching options
      setDefaultOption((prev) => ({
         ...prev,
         sampleFile: "",
      }));

      // Clear bulk upload state when switching away from bulk upload
      if (value !== "bulk_upload") {
         setBulkImages([]);
         setUploadProgress({});
         setBulkUploadResults(null);
      }
   };

   const handleContentTypeChange = (e) => {
      const { value } = e.target;
      setContentType(value);
      setSelectedSource("");
      setTaxonomyGenre("");

      // Automatically set selectedSource for Artist and Language
      if (value === "Artist" || value === "Language") {
         setSelectedSource(value);
      }

      // Clear the sample file when switching content type
      setDefaultOption((prev) => ({
         ...prev,
         sampleFile: "",
      }));

      // Only fetch sample download for non-taxonomy types here
      if (value === "Artist" || value === "Language") {
         setTimeout(() => fetchSampleDownload(value), 1000);
      }
   };

   const handleTaxonomyGenreChange = (e) => {
      const { value } = e.target;
      setTaxonomyGenre(value);
      setSelectedSource(value); // Use the genre as the source for backend compatibility

      if (optionValue === "import" && value) {
         // Fetch genre-specific sample file for import
         setTimeout(() => fetchSampleDownload(value), 1000);
      }
      // Note: For taxonomy exports, we don't need to fetch column lists
      // because taxonomy exports have a predefined structure
   };

   const handleSourceChange = (e) => {
      const { value } = e.target;
      setSelectedSource(value);

      if (optionValue === "export") {
         setTimeout(() => fetchSourceList(value), 1000);
      } else if (optionValue === "import" && value) {
         // Fetch entity-specific sample file for import
         // setTimeout(() => fetchSampleDownload(value), 1000);
      }
   };

   const handleStore = async () => {
      if (optionValue === "import") {
         if (contentType === "") {
            toast.warn("Please select a content type first.");
            return;
         }
         if (contentType === "content_page" && selectedSource === "") {
            toast.warn("Please select a source first.");
            return;
         }
         if (contentType === "taxonomy" && taxonomyGenre === "") {
            toast.warn("Please select a taxonomy genre first.");
            return;
         }
         handleImportData();
      } else if (optionValue === "export") {
         if (contentType === "") {
            toast.warn("Please select a content type first.");
            return;
         }
         if (contentType === "content_page" && selectedSource === "") {
            toast.warn("Please select a source first.");
            return;
         }
         if (contentType === "taxonomy" && taxonomyGenre === "") {
            toast.warn("Please select a taxonomy genre first.");
            return;
         }

         // Use enhanced export for content pages, simple export for taxonomy
         if (contentType === "content_page" && exportType === "enhanced") {
            handleEnhancedExport();
         } else {
            handleSimpleExport();
         }
      } else if (optionValue === "bulk_upload") {
         // Handle bulk upload
         uploadBulkImages();
      }
   };

   const handleInput = (e) => {
      const { name, checked } = e.target;
      const hasValidSource = (contentType === "content_page" && selectedSource !== "") ||
         (contentType === "taxonomy" && taxonomyGenre !== "");

      if (hasValidSource) {
         if (name === "fetchFromLibrary") {
            setFetchFromLibrary(checked);
            setFetchLibraryValue(checked ? 1 : 0);
            setShowEdit(checked);
         }
      } else {
         if (contentType === "content_page") {
            toast.warn("Please select a source first.");
         } else if (contentType === "taxonomy") {
            toast.warn("Please select a taxonomy genre first.");
         } else {
            toast.warn("Please select a content type and source first.");
         }
      }
   };

   const handleCheckboxChange = (field) => {
      setColumnSelection(prev => ({
         ...prev,
         [field]: prev[field] === 1 ? 0 : 1
      }));
   };

   const handlToggle = () => {
      setShowLibraryModal(true);
   };

   const handleFileChange = async (event) => {
      const { files, name, value, accept } = event.target
      const selectedFile = files[0];
      if (selectedFile) {

         const fileExtension = selectedFile?.name?.split('.').pop().toLowerCase();
         const readFile = (file) => {
            return new Promise((resolve, reject) => {
               const reader = new FileReader();
               reader.onload = () => resolve(reader.result);
               reader.onerror = (error) => reject(error);
               reader.readAsDataURL(file);
            });
         };
         const fileContent = await readFile(selectedFile);

         if (fileExtension !== 'xlsx') {
            setFormDataError('Please upload a valid .xlsx file.');
            setFormDataFile(null);
         } else {
            setFormDataFile(selectedFile);
            setFormDataError('');
         }
      }
   }

   const handleClearSelectFile = (value) => {
      setFormDataFile(null)
   }

   const handleClose = () => {
      setExportFileName("");
      setExportFilePath("");
   }

   const handleSelectedData = () => {
      setShowLibraryModal(false);

      const selected = Object.entries(columnSelection)
         .filter(([key, value]) => value === 1)
         .map(([key]) => key);

      setSelectedFields(selected);
   }

   // Bulk Image Upload Functions
   const handleBulkImageDrop = (e) => {
      e.preventDefault();
      setIsDragging(false);

      const files = Array.from(e.dataTransfer.files);
      const imageFiles = files.filter(file => file.type.startsWith('image/'));

      if (imageFiles.length > 0) {
         setBulkImages(prev => [...prev, ...imageFiles]);
      } else {
         toast.warn('Please drop only image files');
      }
   };

   const handleBulkImageSelect = (e) => {
      const files = Array.from(e.target.files);
      const imageFiles = files.filter(file => file.type.startsWith('image/'));

      if (imageFiles.length > 0) {
         setBulkImages(prev => [...prev, ...imageFiles]);
      }

      // Clear input
      e.target.value = '';
   };

   const removeBulkImage = (index) => {
      setBulkImages(prev => prev.filter((_, i) => i !== index));
   };

   const clearAllImages = () => {
      setBulkImages([]);
      setUploadProgress({});
      setBulkUploadResults(null);
   };

   const uploadBulkImages = async () => {
      if (bulkImages.length === 0) {
         toast.warn('Please select images to upload');
         return;
      }

      try {
         setShowOverlay(true);
         const formData = new FormData();

         bulkImages.forEach((file, index) => {
            formData.append('files', file);
         });

         await fetchRequest({
            method: 'POST',
            url: uploadImagesApi,
            data: formData,
            params: {}
         })
            .then(response => {
               if (response?.status) {
                  setBulkUploadResults(response?.data);
                  setBulkImages([]); // Clear uploaded images
                  toast.success(response?.message);
               }
            })
            .catch(error => {
               toast.error(error?.response?.data?.message || 'Upload failed');
            })
            .finally(() => {
               setShowOverlay(false);
            });
      } catch (error) {
         toast.error('Upload failed: ' + error.message);
         setShowOverlay(false);
      }
   };

   const handleDragOver = (e) => {
      e.preventDefault();
      setIsDragging(true);
   };

   const handleDragLeave = (e) => {
      e.preventDefault();
      setIsDragging(false);
   };

   const formatFileSize = (bytes) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
   };

   useEffect(() => {
      document.body.style.overflow = showLibraryModal ? "hidden" : "auto";
   }, [showLibraryModal]);

   useEffect(() => {
      fetchData();
   }, []);

   console.log(defaultOption, "$$$$$$$$$$")

   return (
      <>
         {showOverlay && <Response_Processing />}

         <div className="card p-3">
            <AdminSaveHeader
               heading={optionValue === "bulk_upload" ? "Bulk Image Upload" : "Import/Export Bulk Data"}
               saveText={
                  optionValue === "import" ? "Import Data" :
                     optionValue === "export" ? "Export Data" :
                        optionValue === "bulk_upload" ? "Upload Images" :
                           "Import/Export"
               }
               saveMethod={handleStore}
               loading={showOverlay}
            />

            <div className="row">
               <div className="col-md-3 mb-3">
                  <select className="form-select" onChange={handleOptionChange} value={optionValue}>
                     <option value="">Select Option</option>
                     {options?.map((option, index) => (
                        <option key={index} value={option.value}>{option.name}</option>
                     ))}
                  </select>
               </div>

               {/* New Content Type Dropdown */}
               <div className="col-md-3 mb-3">
                  {(optionValue === "import" || optionValue === "export") && (
                     <select className="form-select" onChange={handleContentTypeChange} value={contentType}>
                        <option value="">Select</option>
                        {contentTypeOptions?.map((type, index) => (
                           <option key={index} value={type.value}>{type.name}</option>
                        ))}
                     </select>
                  )}
               </div>

               {/* Conditional Source/Genre Dropdown */}
               <div className="col-md-3 mb-3">
                  {(optionValue === "import" || optionValue === "export") && contentType === "content_page" && (
                     <select className="form-select" onChange={handleSourceChange} value={selectedSource}>
                        <option value="">Select {optionValue === "import" ? "Import" : "Export"} Source</option>
                        {sourceList?.map((source, index) => (
                           <option key={index} value={source.value}>{source.name}</option>
                        ))}
                     </select>
                  )}
                  {(optionValue === "import" || optionValue === "export") && contentType === "taxonomy" && (
                     <select className="form-select" onChange={handleTaxonomyGenreChange} value={taxonomyGenre}>
                        <option value="">Select Taxonomy Genre</option>
                        {taxonomyGenreOptions?.map((genre, index) => (
                           <option key={index} value={genre.value}>{genre.name}</option>
                        ))}
                     </select>
                  )}
               </div>

               {/* {optionValue === "export" && (
                  <div className="col-md-3 mb-3">
                     <DateRangePicker
                        showOneCalendar={true} cleanable={true} format="dd/MM/yyyy" placeholder="Select date range" appearance="picker"
                        showHeader={false} value={dateRange} onChange={setDateRange} size="md" className="custom-datepicker" ranges={[]}
                     />
                  </div>
               )} */}
            </div>

            {/* Simple Export Options */}
            {optionValue === "export" && (contentType === "content_page" || contentType === "taxonomy" || contentType === "Artist" || contentType === "Language") && (
               <>
                  {/* Basic Export Configuration */}
                  <div className="card p-3 mb-3">
                     <div className="row">
                        <div className="col-md-4">
                           <label className="form-label">Export Format</label>
                           <select
                              className="form-select"
                              value={exportFormat}
                              onChange={(e) => setExportFormat(e.target.value)}
                           >
                              <option value="xlsx">Excel (.xlsx)</option>
                              <option value="csv">CSV (.csv)</option>
                           </select>
                        </div>
                        {contentType === "content_page" && (
                           <div className="col-md-4">
                              <label className="form-label">Export Type</label>
                              <select
                                 className="form-select"
                                 value={exportType}
                                 onChange={(e) => setExportType(e.target.value)}
                              >
                                 <option value="simple">Simple Export</option>
                                 <option value="enhanced">Enhanced Export</option>
                              </select>
                           </div>
                        )}
                        {contentType === "content_page" && exportType === "enhanced" && (
                           <div className="col-md-4">
                              <label className="form-label">Export Mode</label>
                              <select
                                 className="form-select"
                                 value={exportMode}
                                 onChange={(e) => setExportMode(e.target.value)}
                              >
                                 <option value="complete">Complete Data</option>
                                 <option value="selected">Selected Columns</option>
                                 {/* <option value="filtered">With Filters</option> */}
                              </select>
                           </div>
                        )}
                     </div>

                     {/* Enhanced Export Options */}
                     {contentType === "content_page" && exportType === "enhanced" && (
                        <div className="row mt-3">
                           <div className="col-md-6">
                              <div className="form-check">
                                 <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="includeRelationships"
                                    checked={includeRelationships}
                                    onChange={(e) => setIncludeRelationships(e.target.checked)}
                                 />
                                 <label className="form-check-label" htmlFor="includeRelationships">
                                    Include Relationships (Languages, Categories)
                                 </label>
                              </div>
                           </div>
                           <div className="col-md-6">
                              <div className="form-check">
                                 <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="includeCustomFields"
                                    checked={includeCustomFields}
                                    onChange={(e) => setIncludeCustomFields(e.target.checked)}
                                 />
                                 <label className="form-check-label" htmlFor="includeCustomFields">
                                    Include Custom Fields
                                 </label>
                              </div>
                           </div>
                        </div>
                     )}

                     {/* Date Range Picker for Enhanced Export */}
                     {/* {contentType === "content_page" && exportType === "enhanced" && exportMode === "filtered" && (
                        <div className="row mt-3">
                           <div className="col-md-6">
                              <label className="form-label">Date Range Filter</label>
                              <DateRangePicker
                                 showOneCalendar={true} 
                                 cleanable={true} 
                                 format="dd/MM/yyyy" 
                                 placeholder="Select date range" 
                                 appearance="picker"
                                 showHeader={false} 
                                 value={dateRange} 
                                 onChange={setDateRange} 
                                 size="md" 
                                 className="custom-datepicker" 
                                 ranges={[]}
                              />
                           </div>
                        </div>
                     )} */}
                  </div>

                  <div className="row py-3">
                     <div className="col-md-6 mb-3">
                        {/* Enhanced Export Column Selection */}
                        {contentType === "content_page" && exportType === "enhanced" && exportMode === "selected" && (
                           <div className="card p-3">
                              <div className="d-flex align-items-center gap-3">
                                 <MessageLabel text="Select columns to export" />
                                 <span role="button" onClick={handlToggle} style={{ cursor: "pointer" }}>
                                    <IconSolidEdit styled={{ width: "20px", height: "20px" }} />
                                 </span>
                              </div>
                              {selectedFields.length > 0 && (
                                 <small className="text-muted mt-2">
                                    Selected: {selectedFields.join(', ')}
                                 </small>
                              )}
                           </div>
                        )}

                        {exportFilePath && (
                           <div className="card p-3 mt-3">
                              <div className="position-relative d-flex align-items-center px-3 py-2 rounded-2 shadow">
                                 <MessageLabel text={exportFileName} noMargin />
                                 <div className="position-relative d-flex align-items-center gap-2 ms-auto">
                                    <Link to={exportFilePath} className="theme-text-color opacity-75 shadow rounded-5 d-inline-block" target='_blank' download>
                                       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                       </svg>
                                    </Link>
                                 </div>
                                 <button type="button" className="btn-close ms-3 rounded-circle opacity-1 shadow theme-bg-color" onClick={handleClose}></button>
                              </div>
                           </div>
                        )}
                     </div>
                  </div>

                  {showLibraryModal && (
                     <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-lg">
                           <div className="modal-content">
                              <div className="modal-header">
                                 <h5 className="modal-title">Select Fields to Export</h5>
                                 <button type="button" className="btn-close" onClick={() => setShowLibraryModal(false)}></button>
                              </div>
                              <div className="modal-body">
                                 <div className="d-flex flex-wrap gap-2">
                                    {columnList.map((field, index) => (
                                       <div className="border rounded p-2 d-flex align-items-start" key={index} style={{ width: "calc(33.333% - 1rem)", minHeight: "60px", wordWrap: "break-word", whiteSpace: "normal" }} >
                                          <div className="form-check">
                                             <input className="form-check-input" type="checkbox" id={`field-${index}`} checked={columnSelection[field] === 1} onChange={() => handleCheckboxChange(field)} />
                                             <label className="form-check-label ms-2" htmlFor={`field-${index}`} style={{ fontSize: "0.85rem", wordBreak: "break-word" }} >
                                                {field}
                                             </label>
                                          </div>
                                       </div>
                                    ))}
                                 </div>
                              </div>

                              <div className="modal-footer">
                                 <button className="btn btn-secondary" onClick={() => setShowLibraryModal(false)}>Close</button>
                                 <button className="btn btn-primary" onClick={() => handleSelectedData()}>Save Changes</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  )}
               </>
            )}
            {optionValue === "import" && (contentType === "content_page" || contentType === "taxonomy" || contentType === "Artist" || contentType === "Language") && (
               <>
                  <div className="row py-3">
                     <div className="col-md-6 mb-3">
                        <div className="card p-3">
                           <MessageLabel text="Import Excel File" />
                           <AdminImageUploadZone
                              onChange={handleFileChange} selectedFile={formDataFile} onDelete={handleClearSelectFile}
                              ref={(el) => (combinedRef.current.file = el)} name="file" error={formDataError}
                              accept={".xlsx"} icon={<BsFiletypeXlsx />}
                           />
                        </div>
                     </div>
                     <div className="col-md-4 mb-3">
                        <div className="card p-3">
                           <MessageLabel text="Sample Excel File" />
                           {defaultOption?.sampleFile ? (
                              <AdminDownloadFile name="Download Sample" link={defaultOption?.sampleFile} value="yes" />
                           ) : (
                              <p className="text-muted">
                                 {contentType === "taxonomy"
                                    ? "Please select a taxonomy genre to download the sample file"
                                    : "Please select a source to download the sample file"}
                              </p>
                           )}
                        </div>
                     </div>
                  </div>

                  {/* Import Results Display */}
                  {importResults && (
                     <div className="row py-3">
                        <div className="col-md-12 mb-3">
                           <div className="card p-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                 <MessageLabel text="Import Results" />
                                 <button className="btn btn-outline-secondary btn-sm" onClick={() => setImportResults(null)}>
                                    Clear Results
                                 </button>
                              </div>
                              <div className="row">
                                 <div className="col-md-3">
                                    <div className="text-center p-3 border rounded bg-light">
                                       <h5 className="text-primary">{importResults.total}</h5>
                                       <small>Total Records</small>
                                    </div>
                                 </div>
                                 <div className="col-md-3">
                                    <div className="text-center p-3 border rounded bg-success bg-opacity-10">
                                       <h5 className="text-success">{importResults.successful}</h5>
                                       <small>Successful</small>
                                    </div>
                                 </div>
                                 <div className="col-md-3">
                                    <div className="text-center p-3 border rounded bg-danger bg-opacity-10">
                                       <h5 className="text-danger">{importResults.failed}</h5>
                                       <small>Failed</small>
                                    </div>
                                 </div>
                                 <div className="col-md-3 d-flex align-items-center justify-content-center">
                                    <small className="text-muted">
                                       {Math.round((importResults.successful / importResults.total) * 100)}% Success Rate
                                    </small>
                                 </div>
                              </div>

                              {/* Error Details */}
                              {importResults.errors && importResults.errors.length > 0 && (
                                 <div className="mt-3">
                                    <h6 className="text-danger">Error Details ({importResults.errors.length} errors)</h6>
                                    <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                       <table className="table table-sm table-bordered">
                                          <thead>
                                             <tr>
                                                <th width="80">Row</th>
                                                <th>Error</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {importResults.errors.map((error, index) => (
                                                <tr key={index}>
                                                   <td>{error.row}</td>
                                                   <td>{error.error}</td>
                                                </tr>
                                             ))}
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>
                     </div>
                  )}
               </>
            )}

            {/* Bulk Image Upload Section */}
            {optionValue === "bulk_upload" && (
               <>
                  <div className="row py-3">
                     <div className="col-12">
                        <div className="card p-4">
                           <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">Bulk Image Upload</h5>
                              {bulkImages.length > 0 && (
                                 <div className="d-flex gap-2">
                                    <button
                                       className="btn btn-success btn-sm"
                                       onClick={uploadBulkImages}
                                       disabled={showOverlay}
                                    >
                                       Upload {bulkImages.length} Images
                                    </button>
                                    <button
                                       className="btn btn-outline-secondary btn-sm"
                                       onClick={clearAllImages}
                                    >
                                       Clear All
                                    </button>
                                 </div>
                              )}
                           </div>

                           {/* Drag and Drop Zone */}
                           <div
                              className={`border-2 border-dashed rounded p-4 text-center mb-3 ${isDragging ? 'border-primary bg-primary bg-opacity-10' : 'border-secondary'
                                 }`}
                              onDrop={handleBulkImageDrop}
                              onDragOver={handleDragOver}
                              onDragLeave={handleDragLeave}
                              style={{ minHeight: '120px', cursor: 'pointer' }}
                           >
                              <div className="d-flex flex-column align-items-center justify-content-center">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="bi bi-cloud-upload mb-2 text-muted" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z" />
                                    <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z" />
                                 </svg>
                                 <p className="mb-2">
                                    {isDragging ? (
                                       <strong>Drop images here</strong>
                                    ) : (
                                       <><strong>Drag and drop images here</strong> or </>
                                    )}
                                 </p>
                                 {!isDragging && (
                                    <>
                                       <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          onChange={handleBulkImageSelect}
                                          style={{ display: 'none' }}
                                          id="bulk-image-input"
                                       />
                                       <label htmlFor="bulk-image-input" className="btn btn-outline-primary btn-sm">
                                          Choose Files
                                       </label>
                                    </>
                                 )}
                                 <small className="text-muted mt-2">Supports: JPG, PNG, GIF, WebP</small>
                              </div>
                           </div>

                           {/* Selected Images Preview */}
                           {bulkImages.length > 0 && (
                              <div className="mb-3">
                                 <h6>Selected Images ({bulkImages.length})</h6>
                                 <div className="row g-2" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    {bulkImages.map((file, index) => (
                                       <div key={index} className="col-md-3 col-sm-4 col-6">
                                          <div className="card h-100">
                                             <div className="position-relative">
                                                <img
                                                   src={URL.createObjectURL(file)}
                                                   alt={file.name}
                                                   className="card-img-top"
                                                   style={{ height: '120px', objectFit: 'cover' }}
                                                />
                                                <button
                                                   className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                   onClick={() => removeBulkImage(index)}
                                                   style={{ padding: '2px 6px' }}
                                                >
                                                   ×
                                                </button>
                                             </div>
                                             <div className="card-body p-2">
                                                <small className="text-truncate d-block" title={file.name}>
                                                   {file.name}
                                                </small>
                                                <small className="text-muted">
                                                   {formatFileSize(file.size)}
                                                </small>
                                             </div>
                                          </div>
                                       </div>
                                    ))}
                                 </div>
                              </div>
                           )}

                           {/* Upload Results */}
                           {bulkUploadResults && (
                              <div className="mt-3">
                                 <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="mb-0">Upload Results</h6>
                                    <button
                                       className="btn btn-outline-secondary btn-sm"
                                       onClick={() => setBulkUploadResults(null)}
                                    >
                                       Clear Results
                                    </button>
                                 </div>

                                 {/* Summary */}
                                 <div className="row mb-3">
                                    <div className="col-md-3">
                                       <div className="text-center p-3 border rounded bg-light">
                                          <h5 className="text-primary">{bulkUploadResults.summary?.total || 0}</h5>
                                          <small>Total Files</small>
                                       </div>
                                    </div>
                                    <div className="col-md-3">
                                       <div className="text-center p-3 border rounded bg-success bg-opacity-10">
                                          <h5 className="text-success">{bulkUploadResults.summary?.successful || 0}</h5>
                                          <small>Successful</small>
                                       </div>
                                    </div>
                                    <div className="col-md-3">
                                       <div className="text-center p-3 border rounded bg-danger bg-opacity-10">
                                          <h5 className="text-danger">{bulkUploadResults.summary?.failed || 0}</h5>
                                          <small>Failed</small>
                                       </div>
                                    </div>
                                    <div className="col-md-3">
                                       <div className="text-center p-3 border rounded bg-info bg-opacity-10">
                                          <h6 className="text-info">{bulkUploadResults.storage_strategy || 'Local Storage'}</h6>
                                          <small>Storage Used</small>
                                       </div>
                                    </div>
                                 </div>

                                 {/* Uploaded Images */}
                                 {bulkUploadResults.uploaded && bulkUploadResults.uploaded.length > 0 && (
                                    <div className="mb-3">
                                       <h6 className="text-success">Successfully Uploaded ({bulkUploadResults.uploaded.length}) - Storage: {bulkUploadResults.storage_strategy}</h6>
                                       <br />
                                       <div className="table-responsive" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                          <table className="table table-sm table-bordered">
                                             <thead>
                                                <tr>
                                                   <th>Filename</th>
                                                   <th>Site Storage</th>
                                                   <th>AWS S3</th>
                                                   <th>CDN</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {bulkUploadResults.uploaded.map((result, index) => {
                                                   const primaryUrl = result.aws_url || result.bunny_cdn_url || result.site_storage_url;
                                                   return (
                                                      <tr key={index}>
                                                         <td>{result.filename}</td>
                                                         <td>
                                                            {result.site_storage_url ? (
                                                               <span className="text-success">✓</span>
                                                            ) : (
                                                               <span className="text-muted">-</span>
                                                            )}
                                                         </td>
                                                         <td>
                                                            {result.aws_url ? (
                                                               <span className="text-success">✓</span>
                                                            ) : (
                                                               <span className="text-muted">-</span>
                                                            )}
                                                         </td>
                                                         <td>
                                                            {result.bunny_cdn_url ? (
                                                               <span className="text-success">✓</span>
                                                            ) : (
                                                               <span className="text-muted">-</span>
                                                            )}
                                                         </td>
                                                      </tr>
                                                   );
                                                })}
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                 )}

                                 {/* Errors */}
                                 {bulkUploadResults.errors && bulkUploadResults.errors.length > 0 && (
                                    <div className="mb-3">
                                       <h6 className="text-danger">Errors ({bulkUploadResults.errors.length})</h6>
                                       <div className="alert alert-danger">
                                          <ul className="mb-0">
                                             {bulkUploadResults.errors.map((error, index) => (
                                                <li key={index}>{error}</li>
                                             ))}
                                          </ul>
                                       </div>
                                    </div>
                                 )}
                              </div>
                           )}
                        </div>
                     </div>
                  </div>
               </>)}
         </div>
      </>
   );
};

export default ImportExport;
